
import React from 'react';

const Footer: React.FC = () => {
  const navigateToPage = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  return (
    <footer className="bg-[#214134] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo e Informações */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-16 h-16 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/493788cd08f0f0f40d3cddfdb49ed17d.png"
                  alt="Dra. Albiana Guerreiro"
                  className="w-18 h-18"
                />
              </div>
              <div>
                <h3 className="text-xl font-bold">Dra. Albiana Guerreiro</h3>
                <p className="text-gray-300">Advocacia Previdenciária</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Especialista em Direito Previdenciário com 17 anos de experiência. 
              Atendimento humanizado para pessoas com deficiência, aposentadorias e benefícios.
            </p>
            <p className="text-sm text-gray-400">OAB/PR 106594</p>
          </div>

          {/* Contato */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#cc9b3f]">Contato</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-[#cc9b3f]"></i>
                </div>
                <span className="text-gray-300">(44) 98801-9071</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-[#cc9b3f]"></i>
                </div>
                <span className="text-gray-300">contato@albianaguerreiro.com.br</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-instagram-line text-[#cc9b3f]"></i>
                </div>
                <span className="text-gray-300">@guerreiroalbiana</span>
              </div>
            </div>
          </div>

          {/* Endereço */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#cc9b3f]">Endereço</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-line text-[#cc9b3f]"></i>
                </div>
                <div className="text-gray-300">
                  <p>Av. Mandacaru, 886 - Sala 1</p>
                  <p>Maringá/PR</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-[#cc9b3f]"></i>
                </div>
                <div className="text-gray-300">
                  <p>Seg a Sex: 09:00-12:00</p>
                  <p>13:30-17:00</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              <p>&copy; 2025 Dra. Albiana Guerreiro Advocacia. Todos os direitos reservados.</p>
              <p className="mt-1">Este site tem caráter exclusivamente informativo, em conformidade com o Provimento 205/2021 da OAB. Não constitui consultoria individual nem promessa de resultado. Responsável: Dra. Albiana Guerreiro – OAB/PR 106594.</p>
            </div>
            <div className="flex items-center space-x-4">
              <button 
                onClick={() => navigateToPage('/blog')}
                className="text-sm text-gray-400 hover:text-[#cc9b3f] transition-colors cursor-pointer"
              >
                Blog
              </button>
              <button className="text-sm text-gray-400 hover:text-[#cc9b3f] transition-colors cursor-pointer">
                Política de Privacidade
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
